"use strict";
/*
* Created on Wed Feb 05 2020
*/

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ReplenishmentPromoManagementReport_1 = require("../model/ReplenishmentPromoManagementReport");

var AbstractReportConverter_1 = require("./AbstractReportConverter");
/**
 * @author PKr
 * @author Tomáš Leity
 */


var ReplenishmentPromoManagementReportConverter =
/*#__PURE__*/
function (_AbstractReportConver) {
  _inherits(ReplenishmentPromoManagementReportConverter, _AbstractReportConver);

  function ReplenishmentPromoManagementReportConverter() {
    _classCallCheck(this, ReplenishmentPromoManagementReportConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(ReplenishmentPromoManagementReportConverter).apply(this, arguments));
  }

  _createClass(ReplenishmentPromoManagementReportConverter, [{
    key: "toObject",

    /**
     * @inheritDoc
     */
    value: function toObject(source, conversions) {
      return new ReplenishmentPromoManagementReport_1.ReplenishmentPromoManagementReport(ReplenishmentPromoManagementReport_1.ReplenishmentPromoManagementReport.schema.id.valueOfField(source), ReplenishmentPromoManagementReport_1.ReplenishmentPromoManagementReport.schema.promotionIds.valueOf(conversions.asClassReferenceIdsList(source, 'promotionIds')), ReplenishmentPromoManagementReport_1.ReplenishmentPromoManagementReport.schema.categoryIds.valueOf(conversions.asClassReferenceIdsList(source, 'categoryIds')));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, {
        id: source.id,
        promotionIds: conversions.asObjectArray(source, 'promotionIds', function (id) {
          return conversions.toDocumentReferenceId(id);
        }),
        categoryIds: conversions.asObjectArray(source, 'categoryIds', function (id) {
          return conversions.toDocumentReferenceId(id);
        })
      });
      return result;
    }
  }]);

  return ReplenishmentPromoManagementReportConverter;
}(AbstractReportConverter_1.AbstractReportConverter);

exports.ReplenishmentPromoManagementReportConverter = ReplenishmentPromoManagementReportConverter;